import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import UsagePricing from './usagePricing/UsagePricing';
import ShippedItems from './shippedItems/ShippedItems'; //changes ShippedItems
import Adjustments from './adjustments/Adjustments';
import PaymentDetails from './paymentDetails/PaymentDetails';
import { OrderDetailTitle } from 'src/pages/orders/components/orderDetails/OrderDetails.styled';
import { sizes } from 'src/styles/Media.styled';
import {
    OrderDetailFooterContainer,
    InvoiceCreatedDetail,
    WrapperContainer
} from 'src/pages/orders/components/orderDetails/shipAndTrack/ShipAndTrack.styled';
import { useTranslation } from 'react-i18next';
import {
    getDisplayDate,
} from 'src/utils/dateUtils';
import { convertTime24To12 } from 'src/utils/util';
import { checkRequestInvoice } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const BillingSummary = ({ handleSetItemClick, ordersList }) => {
    const [expandedCard, setExpandedCard] = useState({
        isadjustments: true,
        isUsagePricing: true,
        isShippedItems: true,
        isPaymentDetails: true,
    });
    const [orderType,setOrderType] = useState();
    const [isRequestInvoice, setRequestInvoice] = useState(false);
    
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    
    const winWidth = window.innerWidth;
        

    useEffectWithErrorLogging(() =>{
        setOrderType(orderBasicDetails?.currentOrderType);
    },[]);


    const { usagePricing, paymentDetails, adjustments} = useSelector(   
        (state) => state.orderSummaryReducer.billingSummary
    );
    const callToAction = useSelector(
        (state) => state.orderSummaryReducer.callToActionList
    );

    // const { isadjustments, isUsagePricing, isPaymentDetails } = expandedCard; 
    const { isadjustments, isUsagePricing, isPaymentDetails, isShippedItems } = expandedCard;  //changes

    const [modifyDate, setModifyDate] = useState('');
    const [modifyTime, setModifyTime] = useState('');
    const { t } = useTranslation();

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    
    const {                                         
        lastModifiedBy,
        lastModifiedDate,        
    } = useSelector((state) => ({
        orderBasicDetails:
            state.orderSummaryReducer.orderBasicDetails,
        lastModifiedBy:
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail?.lastModifiedBy,
        lastModifiedDate:
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail?.lastModifiedDate      
    }));
 
    useEffectWithErrorLogging(() => {
        if (lastModifiedDate && lastModifiedDate !== '') {
            setModifyDate(
                getDisplayDate(new Date(lastModifiedDate), t('dateFormat'))
            );
            setModifyTime(convertTime24To12(new Date(lastModifiedDate)));
        }
    }, [lastModifiedDate]);

    useEffectWithErrorLogging(() => {
        const requestInvoice = checkRequestInvoice(callToAction);
        if (requestInvoice) {
            setRequestInvoice(true);
        }
    }, [callToAction]);
    return (
        <>
            <OrderDetailTitle mbMargin={isCondensedView && '10px 0px 20px 14px'}>{t('orders.orderDetails.billingSummary.billing')}</OrderDetailTitle>
            {adjustments ? (
                <Adjustments
                    toggleCard={toggleCard}
                    adjustments={isadjustments}
                    handleSetItemClick={handleSetItemClick}
                    ordersList={ordersList}
                    isRequestInvoice={isRequestInvoice}
                />
             ) : null} 
             {/* {orderType==="ZOR" ? (
                <Adjustments
                    toggleCard={toggleCard}
                    adjustments={isadjustments}
                    handleSetItemClick={handleSetItemClick}
                    ordersList={ordersList}
                />
             ) : null}  */}
             
            {usagePricing && orderType!=='ZOR' ? (
                <UsagePricing
                    toggleCard={toggleCard}
                    isUsagePricing={isUsagePricing}
                    handleSetItemClick={handleSetItemClick}
                    ordersList={ordersList}
                />
            ) : null}
            {orderType==='ZOR'&& usagePricing ? (     
                <ShippedItems
                    toggleCard={toggleCard}
                    isShippedItems={isShippedItems}
                    handleSetItemClick={handleSetItemClick}
                    ordersList={ordersList}
                  isBillingSummary ={true}/>
            ) : null}
            {paymentDetails ? (
                <PaymentDetails
                    toggleCard={toggleCard}
                    isPaymentDetails={isPaymentDetails}
                    paddingValue={orderType==='KE' && winWidth <= sizes.mobileDevice ?'16px': null}
                    isRequestInvoice={isRequestInvoice}
                />
            ) : null}

            {orderBasicDetails?.currentOrderType === 'KE' && winWidth <= sizes.mobileDevice ?
                (<OrderDetailFooterContainer>
                    {lastModifiedBy || modifyDate || modifyTime ? (
                        <>
                            <InvoiceCreatedDetail
                                margin={'0 3px 0 0'}
                            >{isLanguageChanged && lastModifiedBy?'':t('orders.orderSummaryTabs.lastmodify')}</InvoiceCreatedDetail>
                            {lastModifiedBy ? (
                                <>
                                    <InvoiceCreatedDetail
                                        margin={'0 3px 0 0'}
                                    >{isLanguageChanged ?t('orders.orderSummaryTabs.lastmodify'):t('orders.orderDetails.billingSummary.by')}</InvoiceCreatedDetail>
                                    <InvoiceCreatedDetail
                                        margin={'0 2px 0 0'}
                                        isCreatedDateBy
                                    >
                                        {lastModifiedBy}
                                    </InvoiceCreatedDetail>
                                </>
                            ) : null}
                            <WrapperContainer>
                                {modifyDate ? (
                                    <InvoiceCreatedDetail margin={'0 2px 0 -1px'}>
                                        {modifyDate}
                                    </InvoiceCreatedDetail>
                                ) : null}
                                {modifyTime ? (
                                    <InvoiceCreatedDetail>
                                        {modifyTime} {' '+'IST'}
                                    </InvoiceCreatedDetail>
                                ) : null}
                            </WrapperContainer>
                        </>
                    ) : null}
                </OrderDetailFooterContainer>)
                : null
            }
        </>
    );
};

export default BillingSummary;
